// removed by extract-text-webpack-plugin
module.exports = {"theme":"\"light\""};


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/_variables.scss
// module id = wr+4
// module chunks = 1